<template>
  <six-ft-apart v-if="valueName == '6_ft_apart'" />
  <architecture v-else-if="valueName == 'architecture'" />
  <cake v-else-if="valueName == 'cake'" />
  <clean-hands v-else-if="valueName == 'clean_hands'" />
  <connect-without-contact v-else-if="valueName == 'connect_without_contact'" />
  <construction v-else-if="valueName == 'construction'" />
  <coronavirus v-else-if="valueName == 'coronavirus'" />
  <deck v-else-if="valueName == 'deck'" />
  <domain v-else-if="valueName == 'domain'" />
  <elderly v-else-if="valueName == 'elderly'" />
  <emoji-emotions v-else-if="valueName == 'emoji_emotions'" />
  <emoji-events v-else-if="valueName == 'emoji_events'" />
  <emoji-flags v-else-if="valueName == 'emoji_flags'" />
  <emoji-food-beverage v-else-if="valueName == 'emoji_food_beverage'" />
  <emoji-nature v-else-if="valueName == 'emoji_nature'" />
  <emoji-objects v-else-if="valueName == 'emoji_objects'" />
  <emoji-people v-else-if="valueName == 'emoji_people'" />
  <emoji-symbols v-else-if="valueName == 'emoji_symbols'" />
  <emoji-transportation v-else-if="valueName == 'emoji_transportation'" />
  <engineering v-else-if="valueName == 'engineering'" />
  <facebook v-else-if="valueName == 'facebook'" />
  <fireplace v-else-if="valueName == 'fireplace'" />
  <follow-the-signs v-else-if="valueName == 'follow_the_signs'" />
  <group v-else-if="valueName == 'group'" />
  <group-add v-else-if="valueName == 'group_add'" />
  <groups v-else-if="valueName == 'groups'" />
  <history-edu v-else-if="valueName == 'history_edu'" />
  <king-bed v-else-if="valueName == 'king_bed'" />
  <location-city v-else-if="valueName == 'location_city'" />
  <luggage v-else-if="valueName == 'luggage'" />
  <masks v-else-if="valueName == 'masks'" />
  <military-tech v-else-if="valueName == 'military_tech'" />
  <mood v-else-if="valueName == 'mood'" />
  <mood-bad v-else-if="valueName == 'mood_bad'" />
  <nights-stay v-else-if="valueName == 'nights_stay'" />
  <no-luggage v-else-if="valueName == 'no_luggage'" />
  <notifications v-else-if="valueName == 'notifications'" />
  <notifications-active v-else-if="valueName == 'notifications_active'" />
  <notifications-none v-else-if="valueName == 'notifications_none'" />
  <notifications-off v-else-if="valueName == 'notifications_off'" />
  <notifications-paused v-else-if="valueName == 'notifications_paused'" />
  <outdoor-grill v-else-if="valueName == 'outdoor_grill'" />
  <pages v-else-if="valueName == 'pages'" />
  <party-mode v-else-if="valueName == 'party_mode'" />
  <people v-else-if="valueName == 'people'" />
  <people-alt v-else-if="valueName == 'people_alt'" />
  <people-outline v-else-if="valueName == 'people_outline'" />
  <person v-else-if="valueName == 'person'" />
  <person-add v-else-if="valueName == 'person_add'" />
  <person-add-alt-1 v-else-if="valueName == 'person_add_alt_1'" />
  <person-outline v-else-if="valueName == 'person_outline'" />
  <person-remove v-else-if="valueName == 'person_remove'" />
  <person-remove-alt-1 v-else-if="valueName == 'person_remove_alt_1'" />
  <plus-one v-else-if="valueName == 'plus_one'" />
  <poll v-else-if="valueName == 'poll'" />
  <precision-manufacturing v-else-if="valueName == 'precision_manufacturing'" />
  <psychology v-else-if="valueName == 'psychology'" />
  <public v-else-if="valueName == 'public'" />
  <public-off v-else-if="valueName == 'public_off'" />
  <reduce-capacity v-else-if="valueName == 'reduce_capacity'" />
  <sanitizer v-else-if="valueName == 'sanitizer'" />
  <school v-else-if="valueName == 'school'" />
  <science v-else-if="valueName == 'science'" />
  <self-improvement v-else-if="valueName == 'self_improvement'" />
  <sentiment-dissatisfied v-else-if="valueName == 'sentiment_dissatisfied'" />
  <sentiment-neutral v-else-if="valueName == 'sentiment_neutral'" />
  <sentiment-satisfied v-else-if="valueName == 'sentiment_satisfied'" />
  <sentiment-very-dissatisfied
    v-else-if="valueName == 'sentiment_very_dissatisfied'"
  />
  <sentiment-very-satisfied
    v-else-if="valueName == 'sentiment_very_satisfied'"
  />
  <share v-else-if="valueName == 'share'" />
  <sick v-else-if="valueName == 'sick'" />
  <single-bed v-else-if="valueName == 'single_bed'" />
  <sports v-else-if="valueName == 'sports'" />
  <sports-baseball v-else-if="valueName == 'sports_baseball'" />
  <sports-basketball v-else-if="valueName == 'sports_basketball'" />
  <sports-cricket v-else-if="valueName == 'sports_cricket'" />
  <sports-esports v-else-if="valueName == 'sports_esports'" />
  <sports-football v-else-if="valueName == 'sports_football'" />
  <sports-golf v-else-if="valueName == 'sports_golf'" />
  <sports-handball v-else-if="valueName == 'sports_handball'" />
  <sports-hockey v-else-if="valueName == 'sports_hockey'" />
  <sports-kabaddi v-else-if="valueName == 'sports_kabaddi'" />
  <sports-mma v-else-if="valueName == 'sports_mma'" />
  <sports-motorsports v-else-if="valueName == 'sports_motorsports'" />
  <sports-rugby v-else-if="valueName == 'sports_rugby'" />
  <sports-soccer v-else-if="valueName == 'sports_soccer'" />
  <sports-tennis v-else-if="valueName == 'sports_tennis'" />
  <sports-volleyball v-else-if="valueName == 'sports_volleyball'" />
  <thumb-down-alt v-else-if="valueName == 'thumb_down_alt'" />
  <thumb-up-alt v-else-if="valueName == 'thumb_up_alt'" />
  <whatshot v-else-if="valueName == 'whatshot'" />
</template>

<script>
import SixFtApart from "@/components/Icons/Social/SixFtApart";
import Architecture from "@/components/Icons/Social/Architecture";
import Cake from "@/components/Icons/Social/Cake";
import CleanHands from "@/components/Icons/Social/CleanHands";
import ConnectWithoutContact from "@/components/Icons/Social/ConnectWithoutContact";
import Construction from "@/components/Icons/Social/Construction";
import Coronavirus from "@/components/Icons/Social/Coronavirus";
import Deck from "@/components/Icons/Social/Deck";
import Domain from "@/components/Icons/Social/Domain";
import Elderly from "@/components/Icons/Social/Elderly";
import EmojiEmotions from "@/components/Icons/Social/EmojiEmotions";
import EmojiEvents from "@/components/Icons/Social/EmojiEvents";
import EmojiFlags from "@/components/Icons/Social/EmojiFlags";
import EmojiFoodBeverage from "@/components/Icons/Social/EmojiFoodBeverage";
import EmojiNature from "@/components/Icons/Social/EmojiNature";
import EmojiObjects from "@/components/Icons/Social/EmojiObjects";
import EmojiPeople from "@/components/Icons/Social/EmojiPeople";
import EmojiSymbols from "@/components/Icons/Social/EmojiSymbols";
import EmojiTransportation from "@/components/Icons/Social/EmojiTransportation";
import Engineering from "@/components/Icons/Social/Engineering";
import Facebook from "@/components/Icons/Social/Facebook";
import Fireplace from "@/components/Icons/Social/Fireplace";
import FollowTheSigns from "@/components/Icons/Social/FollowTheSigns";
import Group from "@/components/Icons/Social/Group";
import GroupAdd from "@/components/Icons/Social/GroupAdd";
import Groups from "@/components/Icons/Social/Groups";
import HistoryEdu from "@/components/Icons/Social/HistoryEdu";
import KingBed from "@/components/Icons/Social/KingBed";
import LocationCity from "@/components/Icons/Social/LocationCity";
import Luggage from "@/components/Icons/Social/Luggage";
import Masks from "@/components/Icons/Social/Masks";
import MilitaryTech from "@/components/Icons/Social/MilitaryTech";
import Mood from "@/components/Icons/Social/Mood";
import MoodBad from "@/components/Icons/Social/MoodBad";
import NightsStay from "@/components/Icons/Social/NightsStay";
import NoLuggage from "@/components/Icons/Social/NoLuggage";
import Notifications from "@/components/Icons/Social/Notifications";
import NotificationsActive from "@/components/Icons/Social/NotificationsActive";
import NotificationsNone from "@/components/Icons/Social/NotificationsNone";
import NotificationsOff from "@/components/Icons/Social/NotificationsOff";
import NotificationsPaused from "@/components/Icons/Social/NotificationsPaused";
import OutdoorGrill from "@/components/Icons/Social/OutdoorGrill";
import Pages from "@/components/Icons/Social/Pages";
import PartyMode from "@/components/Icons/Social/PartyMode";
import People from "@/components/Icons/Social/People";
import PeopleAlt from "@/components/Icons/Social/PeopleAlt";
import PeopleOutline from "@/components/Icons/Social/PeopleOutline";
import Person from "@/components/Icons/Social/Person";
import PersonAdd from "@/components/Icons/Social/PersonAdd";
import PersonAddAlt1 from "@/components/Icons/Social/PersonAddAlt1";
import PersonOutline from "@/components/Icons/Social/PersonOutline";
import PersonRemove from "@/components/Icons/Social/PersonRemove";
import PersonRemoveAlt1 from "@/components/Icons/Social/PersonRemoveAlt1";
import PlusOne from "@/components/Icons/Social/PlusOne";
import Poll from "@/components/Icons/Social/Poll";
import PrecisionManufacturing from "@/components/Icons/Social/PrecisionManufacturing";
import Psychology from "@/components/Icons/Social/Psychology";
import Public from "@/components/Icons/Social/Public";
import PublicOff from "@/components/Icons/Social/PublicOff";
import ReduceCapacity from "@/components/Icons/Social/ReduceCapacity";
import Sanitizer from "@/components/Icons/Social/Sanitizer";
import School from "@/components/Icons/Social/School";
import Science from "@/components/Icons/Social/Science";
import SelfImprovement from "@/components/Icons/Social/SelfImprovement";
import SentimentDissatisfied from "@/components/Icons/Social/SentimentDissatisfied";
import SentimentNeutral from "@/components/Icons/Social/SentimentNeutral";
import SentimentSatisfied from "@/components/Icons/Social/SentimentSatisfied";
import SentimentVeryDissatisfied from "@/components/Icons/Social/SentimentVeryDissatisfied";
import SentimentVerySatisfied from "@/components/Icons/Social/SentimentVerySatisfied";
import Share from "@/components/Icons/Social/Share";
import Sick from "@/components/Icons/Social/Sick";
import SingleBed from "@/components/Icons/Social/SingleBed";
import Sports from "@/components/Icons/Social/Sports";
import SportsBaseball from "@/components/Icons/Social/SportsBaseball";
import SportsBasketball from "@/components/Icons/Social/SportsBasketball";
import SportsCricket from "@/components/Icons/Social/SportsCricket";
import SportsEsports from "@/components/Icons/Social/SportsEsports";
import SportsFootball from "@/components/Icons/Social/SportsFootball";
import SportsGolf from "@/components/Icons/Social/SportsGolf";
import SportsHandball from "@/components/Icons/Social/SportsHandball";
import SportsHockey from "@/components/Icons/Social/SportsHockey";
import SportsKabaddi from "@/components/Icons/Social/SportsKabaddi";
import SportsMma from "@/components/Icons/Social/SportsMma";
import SportsMotorsports from "@/components/Icons/Social/SportsMotorsports";
import SportsRugby from "@/components/Icons/Social/SportsRugby";
import SportsSoccer from "@/components/Icons/Social/SportsSoccer";
import SportsTennis from "@/components/Icons/Social/SportsTennis";
import SportsVolleyball from "@/components/Icons/Social/SportsVolleyball";
import ThumbDownAlt from "@/components/Icons/Social/ThumbDownAlt";
import ThumbUpAlt from "@/components/Icons/Social/ThumbUpAlt";
import Whatshot from "@/components/Icons/Social/Whatshot";

export default {
  components: {
    SixFtApart,
    Architecture,
    Cake,
    CleanHands,
    ConnectWithoutContact,
    Construction,
    Coronavirus,
    Deck,
    Domain,
    Elderly,
    EmojiEmotions,
    EmojiEvents,
    EmojiFlags,
    EmojiFoodBeverage,
    EmojiNature,
    EmojiObjects,
    EmojiPeople,
    EmojiSymbols,
    EmojiTransportation,
    Engineering,
    Facebook,
    Fireplace,
    FollowTheSigns,
    Group,
    GroupAdd,
    Groups,
    HistoryEdu,
    KingBed,
    LocationCity,
    Luggage,
    Masks,
    MilitaryTech,
    Mood,
    MoodBad,
    NightsStay,
    NoLuggage,
    Notifications,
    NotificationsActive,
    NotificationsNone,
    NotificationsOff,
    NotificationsPaused,
    OutdoorGrill,
    Pages,
    PartyMode,
    People,
    PeopleAlt,
    PeopleOutline,
    Person,
    PersonAdd,
    PersonAddAlt1,
    PersonOutline,
    PersonRemove,
    PersonRemoveAlt1,
    PlusOne,
    Poll,
    PrecisionManufacturing,
    Psychology,
    Public,
    PublicOff,
    ReduceCapacity,
    Sanitizer,
    School,
    Science,
    SelfImprovement,
    SentimentDissatisfied,
    SentimentNeutral,
    SentimentSatisfied,
    SentimentVeryDissatisfied,
    SentimentVerySatisfied,
    Share,
    Sick,
    SingleBed,
    Sports,
    SportsBaseball,
    SportsBasketball,
    SportsCricket,
    SportsEsports,
    SportsFootball,
    SportsGolf,
    SportsHandball,
    SportsHockey,
    SportsKabaddi,
    SportsMma,
    SportsMotorsports,
    SportsRugby,
    SportsSoccer,
    SportsTennis,
    SportsVolleyball,
    ThumbDownAlt,
    ThumbUpAlt,
    Whatshot,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
